import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  // 用來儲存 index.html 原本預設內容的變數
  private initialTitle = '';
  private initialDesc = '';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private metaService: Meta
  ) {}

  ngOnInit() {
    // 在一開始，先抓取 index.html 裡面本來就寫好的文字
    this.initialTitle = this.titleService.getTitle();
    this.initialDesc = this.metaService.getTag('name="description"')?.content || '';

    this.router.events.pipe(
      // 1. 只篩選出路由導航結束的事件
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {

      // 2. 改用正向爬軌跡的方式，沿路把 data 合併起來，這樣既能拿到最深層的 title，也能保留父層的 isfundrich
      let route = this.activatedRoute.root;
      let routeData = { ...route.snapshot.data };

      while (route.firstChild) {
        route = route.firstChild;
        // 後面的子路由 data 會覆蓋或合併前面的父路由 data
        routeData = { ...routeData, ...route.snapshot.data };
      }

      // 3. 設定 Title（若子頁面沒設定，就用全站預設值）
      if (routeData['title']) {
        this.titleService.setTitle(routeData['title']);
      } else {
        this.titleService.setTitle(this.initialTitle);
      }

      // 4. 設定 Meta Description（若子頁面沒設定，就用全站預設值）
      if (routeData['description']) {
        this.metaService.updateTag({ name: 'description', content: routeData['description'] });
      } else if (this.initialDesc) {
        this.metaService.updateTag({ name: 'description', content: this.initialDesc });
      }

    });
  }
}
